import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from 'components/HookForm';
import { updateSmartSpot as updateSmartSpotAction } from 'components/SmartSpot';
import { SMARTSPOT_REASON } from 'constants/logic';
import { SMARTSPOT_UPDATE_SOURCE } from 'constants/tracking';
import { selectActiveVenue, selectVenueSmartspotData } from 'selectors/general';
import { trackReleaseExtraSpotsUpdated } from './SmartTools.helpers';

import SmartSpotOnboardingReleaseExtraSpots from './SmartSpotOnboardingReleaseExtraSpots';

const SmartSpotOnboardingReleaseExtraSpotsForm = ({
  formName,
  isLoading,
  countryCode,
  handleLearnMore,
  onSkip,
  onNext,
  showSelectOptionPeakTime,
  showSelectOptionOffPeakTime,
}) => {
  const dispatch = useDispatch();
  const venueData = useSelector(selectActiveVenue);
  const { venueId, venueName, venueSubtitle } = venueData;
  const { allRemainingSpotsPeakTime, allRemainingSpotsOffpeakTime, isEnabled } = useSelector(state =>
    selectVenueSmartspotData(state)
  );

  const initialValues = {
    releaseExtraSpotsPeakTime: allRemainingSpotsPeakTime,
    releaseExtraSpotsOffPeakTime: allRemainingSpotsOffpeakTime,
  };

  const handleSubmit = (formValues, formAsyncFns) => {
    const { releaseExtraSpotsPeakTime, releaseExtraSpotsOffPeakTime } = formValues;

    const values = {
      isEnabled,
      allRemainingSpotsPeakTime: releaseExtraSpotsPeakTime,
      allRemainingSpotsOffpeakTime: releaseExtraSpotsOffPeakTime,
    };

    trackReleaseExtraSpotsUpdated(venueId, releaseExtraSpotsPeakTime, releaseExtraSpotsOffPeakTime, initialValues);

    const meta = {
      venueId,
      venueName,
      venueSubtitle,
      reason: SMARTSPOT_REASON.GENERIC_UPDATE,
      source: SMARTSPOT_UPDATE_SOURCE.SMART_TOOLS,
    };

    return dispatch(updateSmartSpotAction(values, meta, formAsyncFns));
  };

  return (
    <Form id={formName} defaultValues={initialValues} isLoading={isLoading} onSubmit={handleSubmit}>
      {function FormRender({ control, submit, formState }) {
        const { isSubmitting, isDirty } = formState;

        const isNextDisabled =
          (allRemainingSpotsPeakTime === null || allRemainingSpotsPeakTime === 0) &&
          (allRemainingSpotsOffpeakTime === null || allRemainingSpotsOffpeakTime === 0) &&
          !isDirty;

        const handleNext = async () => {
          await submit();
          onNext();
        };

        return (
          <SmartSpotOnboardingReleaseExtraSpots
            control={control}
            countryCode={countryCode}
            handleLearnMore={handleLearnMore}
            onSkip={onSkip}
            onNext={handleNext}
            isSubmitting={isSubmitting}
            isNextDisabled={isNextDisabled}
            showSelectOptionPeakTime={showSelectOptionPeakTime}
            showSelectOptionOffPeakTime={showSelectOptionOffPeakTime}
          />
        );
      }}
    </Form>
  );
};

SmartSpotOnboardingReleaseExtraSpotsForm.propTypes = {
  formName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  countryCode: PropTypes.string,
  handleLearnMore: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  showSelectOptionPeakTime: PropTypes.bool.isRequired,
  showSelectOptionOffPeakTime: PropTypes.bool.isRequired,
};

export default SmartSpotOnboardingReleaseExtraSpotsForm;
